import { RESERVATION_STATUS } from '@/enums/reservationStatus'

export function reservationCheckinStatus(reservation) {
    if (!reservation) return '';

    if (reservation.status === RESERVATION_STATUS.CANCELED) return 'row-status-grey';

    const total = (reservation.paxTotal || 0);
    const checked = (reservation.paxCheckedIn || 0);
    const noShow = (reservation.paxNoShow || 0);

    const paxResolved = checked + noShow;
    if ((paxResolved > 0 && paxResolved < total) || (checked > 0 && noShow > 0)) return 'row-status-yellow';
    if (total === 0) return '';
    if (checked === total) return 'row-status-green';
    if (noShow === total) return 'row-status-red';
}



// WEBPACK FOOTER //
// ./src/utils/reservationRowClass.js